import { Static, Type } from '@sinclair/typebox';

export const EmailNotificationMetadataSchema = Type.Object(
  {
    topic: Type.String({ minLength: 1 }),
    dedupe_key: Type.String({ minLength: 1 }),
    reference_type: Type.Optional(Type.String({ minLength: 1 })),
    reference_id: Type.Optional(Type.String({ minLength: 1 })),
    metadata: Type.Optional(Type.Record(Type.String(), Type.Unknown())),
    recipient: Type.String({ minLength: 1 }),
    template: Type.String({ minLength: 1 }),
    subject: Type.String({ minLength: 1 }),
  },
  { additionalProperties: false }
);

export type EmailNotificationMetadata = Static<
  typeof EmailNotificationMetadataSchema
>;
